import { DIGISAKA_API_ORIGIN } from '../../../config/digisakaApiOrigin';
/**
 * Cavite Silang drone COGs (Leads Agri_Drone Outputs).
 *
 * NDVI + ortho use Titiler `WebMercatorQuad` XYZ tiles (`bidx=1,2,3` RGB), same as Isabela PhilRice.
 */

export const CAVITE_SILANG_COG_URLS = {
  ndvi: 'https://digisaka.s3.amazonaws.com/Leads+Agri_Drone+Outputs/Cavite_Silang/SilangFarmLeadsOct_NDVI.tif',
  ortho: 'https://digisaka.s3.amazonaws.com/Leads+Agri_Drone+Outputs/Cavite_Silang/SilangFarmLeadsOct_Ortho.tif',
} as const;

export type CaviteSilangKind = keyof typeof CAVITE_SILANG_COG_URLS;

const PREVIEW_BASE = DIGISAKA_API_ORIGIN + '/api/preview';

const TITILER_TILE_BASE = DIGISAKA_API_ORIGIN + '/api/tiles/WebMercatorQuad/{z}/{x}/{y}@2x.png';

/** WebMercatorQuad XYZ — 3-band RGB (NDVI + ortho). */
export function buildCaviteSilangTileUrl(kind: CaviteSilangKind): string {
  const u = `${TITILER_TILE_BASE}?url=${encodeURIComponent(CAVITE_SILANG_COG_URLS[kind])}`;
  return `${u}&bidx=1&bidx=2&bidx=3&resampling=lanczos`;
}

/** Layer-list thumbnails — match Titiler params used on the map. */
export function buildCaviteSilangPreviewUrl(kind: CaviteSilangKind, maxSize = 160): string {
  const url = CAVITE_SILANG_COG_URLS[kind];
  const q = `url=${encodeURIComponent(url)}`;
  return `${PREVIEW_BASE}?${q}&max_size=${maxSize}&bidx=1&bidx=2&bidx=3`;
}
